"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputVM = exports.Text = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const logger_1 = tslib_1.__importDefault(require("@zajno/common/logger"));
const getter_1 = require("@zajno/common/types/getter");
const Validatable_1 = require("./Validatable");
function FromGetter(getter, setter, autorunDelay = null, noAutorun = null) {
    if (noAutorun || typeof getter !== 'function') {
        setter(getter_1.Getter.getValue(getter));
        return null;
    }
    return (0, mobx_1.reaction)(() => getter_1.Getter.getValue(getter), setter, { delay: autorunDelay, fireImmediately: true });
}
class Text {
    constructor(config) {
        this._value = null;
        (0, mobx_1.makeObservable)(this, { _value: mobx_1.observable });
        FromGetter(config.value, val => this._value = val, config.async ? 100 : null, config.noSubscribe);
    }
    get value() { return this._value; }
}
exports.Text = Text;
class TextInputVM extends Validatable_1.ValidatableModel {
    constructor(config) {
        super();
        this._value = '';
        this._focused = false;
        this._name = null;
        this._title = null;
        this._valueObserving = null;
        this.setValue = (value) => {
            if (!this._valueObserving) {
                this._value = value;
                if (this._validateOnChange) {
                    this.validate();
                }
            }
            else {
                logger_1.default.warn('[TextInputVM] Setting value is not allowed when value is observing');
            }
        };
        this.setFocused = (value = true) => {
            this._focused = value;
            if (!value) {
                this.onBlur();
                return;
            }
            super.reset();
        };
        this.reset = (0, mobx_1.action)(() => {
            this._value = '';
            this._focused = false;
            super.reset();
        });
        config = config || {};
        const delay = config.async ? 100 : null;
        FromGetter(config.name, val => this._name = val, delay);
        FromGetter(config.title, val => this._title = val, delay);
        this._valueObserving = FromGetter(config.value, v => (0, mobx_1.runInAction)(() => this._value = v), delay);
        (0, mobx_1.makeObservable)(this, {
            _value: mobx_1.observable,
            _focused: mobx_1.observable,
            setValue: mobx_1.action,
            setFocused: mobx_1.action,
        });
    }
    get value() { return this._value; }
    get name() { return this._name; }
    get title() { return this._title; }
    set value(val) {
        this.setValue(val);
    }
    get isEmpty() {
        return !this._value;
    }
    get focused() {
        return this._focused;
    }
    set focused(val) {
        this.setFocused(val);
    }
    get valueToValidate() { var _a; return ((_a = this.value) !== null && _a !== void 0 ? _a : '').trim(); }
    onBlur() {
        this.validate();
    }
}
exports.TextInputVM = TextInputVM;
//# sourceMappingURL=TextModel.js.map